import React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Soft-tinted status pill: a palette-derived alpha fill behind solid-color
// text, theme-aware. Shared so any status/state chip across admin (Fleet
// vehicle status, referral status, etc.) reads the same instead of each
// caller re-deriving the alpha-fill recipe. `palette` is nullable, which
// renders a quiet neutral tint for a "nothing has happened yet" state
// instead of borrowing one of the semantic (success/accent/error) hues.
// `dense` is for a pill that sits inline beside a row's label text rather than in
// a column of its own.
const TintedStatusPill = ({ palette, label, dense = false }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: dense ? '1px 8px' : '3px 12px',
      borderRadius: '16px',
      fontSize: dense ? '11px' : '12.5px',
      fontWeight: 600,
      // An inline pill must not break at "Non-refundable"'s hyphen.
      ...(dense && { whiteSpace: 'nowrap' }),
      color: palette ? (theme) => theme.palette[palette].main : 'text.secondary',
      backgroundColor: palette
        ? (theme) => alpha(theme.palette[palette].main, theme.palette.mode === 'dark' ? 0.18 : 0.14)
        : (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'),
    }}
  >
    {label}
  </Box>
);

export default TintedStatusPill;
